import Badge from "../common/Badge";
import { useAuth } from "../../contexts/AuthContext";

export default function TopBar({ title, rightContent }) {
  const { profile, signOutUser } = useAuth();
  const isAdmin = profile?.role === "admin";

  return (
    <header className="topbar">
      <h1>{title}</h1>
      {rightContent || (
        <div className="topbar-actions">
          <span className="muted" style={{ marginRight: 2 }}>
            {profile?.displayName}
          </span>
          <Badge tone={isAdmin ? "admin" : "standard"}>{isAdmin ? "Admin" : "Standard"}</Badge>
          <button type="button" className="btn btn-secondary" onClick={signOutUser}>
            Logout
          </button>
        </div>
      )}
    </header>
  );
}
